import { Container, Row, Col, Card, Badge, Form, Button } from "react-bootstrap";
import { studyOnboardingService } from "../APIServices/studyOnboarding";
import { useEffect, useState } from "react";
import { userServices } from "../APIServices/userServices";
import SplitPane from "react-split-pane";
import AccessRequestPortal from "./Roles/UserManagement/AccessRequestPortal/AccessRequestPortal";

const StudySelectionPage = () => {
  const [studies, setStudies] = useState([])
  const getTotalAssignedStudies = async () => {
    let data = await studyOnboardingService.getTotalAssignedStudies()
    setStudies(data?.data || [])
  }

  const studyLoginFunction = (studyId, studyLabel, projectLabel) => {
    localStorage.setItem("loginType", JSON.stringify("apps"));
    localStorage.setItem("studyId", JSON.stringify(studyId));
    localStorage.setItem("studyName", JSON.stringify(studyLabel));
    localStorage.setItem("projectName", JSON.stringify(projectLabel));
    window.location.reload();
  }

  const [greeting, setGreeting] = useState("");
  const userName = JSON.parse(localStorage.getItem("firstName"));
  const getGreeting = () => {
    const currentTime = new Date().getHours();
    let greeting;

    if (currentTime >= 5 && currentTime < 12) {
      greeting = "Good Morning";
    } else if (currentTime >= 12 && currentTime < 18) {
      greeting = "Good Afternoon";
    } else {
      greeting = "Good Evening";
    }
    setGreeting(greeting);
  };

  useEffect(() => {
    getGreeting();
  }, []);

  const logout = async () => {
    await userServices.logout();
  };

  useEffect(() => {
    getTotalAssignedStudies()
  }, []);
  return (
    <>
      <div style={{ background: "var(--blue)" }}>
        <div className="hstack justify-content-between border-bottom border-secondary px-2 py-1">
          <h4 className="text-white m-0">Galax®</h4>
          <Button
            onClick={logout}
            variant="outline-danger"
            className="p-1 px-2 border-0 br3 hstack"
            style={{ fontSize: 13 }}
            title="Sign out from panel"
          >
            <i className="fa-solid fa-right-from-bracket me-1" style={{marginBottom: -2}}></i><span>Signout</span>
          </Button>
        </div>
      </div>
      <div className="p-3 text-center border-bottom">
        <h4 className="mb-0">{greeting}! {userName}</h4>
        <p className="m-0">You can access your Studies</p>
      </div>
      <SplitPane
        split="vertical"
        className="position-relative"
        style={{ height: "calc(100vh - 124px)" }}
        minSize={20}
        defaultSize={"60%"}
      >
        <Container fluid>
          <Row className="g-2 py-3">
            {studies.map((study, idx) => (
              <Col key={idx} md={4} >
                <Card className="h-100 shadow-sm app-card">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="m-0 d-block fw-bold">
                        {study?.studyLabel}
                      </h6>
                      <Badge className="bg-success br3" style={{ fontSize: 9 }}>Active</Badge>
                    </div>
                    <div className="mb-2">
                      <Form.Label className="mb-1 d-block">
                        <span className="fw-medium">Project:</span> {study.projectLabel}
                      </Form.Label>
                      <Form.Label className="mb-1 d-block">
                        <span className="fw-medium">Client:</span> {study.clientName}
                      </Form.Label>
                    </div>
                    <button
                      onClick={() => studyLoginFunction(study?.studyId, study?.studyLabel, study.projectLabel)}
                      className="updateProfile">
                      Login →
                    </button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
        <AccessRequestPortal  />
      </SplitPane>
    </>
  );
};

export default StudySelectionPage;
